import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { GetSportPagination } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'
import { BASE_URL } from '../../constants/Common';
// import { SportQ } from '../../graphqlDic'
import {Link} from 'react-router-dom'
class SportCateDetail extends Component {
    constructor(props){
        super(props);
        this.state = {
            sports:'', 
            sport_count:''
        }
    }
    componentWillMount() {
        if (!!this.props.getSportPagination.getSportPagination) {
                this.setState({
                    sports: this.props.getSportPagination.getSportPagination
                });
            }
        }
    componentWillReceiveProps(nextProps) {
        if (!!nextProps.getSportPagination.getSportPagination) {
            this.setState({
                sports: nextProps.getSportPagination.getSportPagination
              });
          }
      }
      setPage = () => {
          this.props.setPage();
          this.setState({
              sport_count:this.state.sports.length
          })
      }
  render() {
    if (this.props.getSportPagination.loading) return "Loading...";
    if (this.props.getSportPagination.error) return `Error! ${this.props.getSportPagination.error.message}`;
    var sport_cate_detail = this.state.sports;
    var item_media = sport_cate_detail.length ?  sport_cate_detail.map((item,i) =>
        <div className="unit" key={i}>
            <div className="img">
                <Link to={"/the-thao/"+this.props.cate.slug+"/watch/"+item.id}>
                <img src={ BASE_URL+item.img  }  className="img-responsive" alt="true" />
                <img src={BASE_URL+"images/icon-play2.png"}  className="play" alt="true" />
                </Link>
            </div>
            <Link to={"/the-thao/"+this.props.cate.slug+"/watch/"+item.id}>{item.name}</Link>
            <div className="time">{item.created_date}</div>
        </div>
    ) : <p>Không có dữ liệu</p>
    return (
       <Fragment>
            <div className="unit-wrap row" >
            {item_media}
            </div>
            {   this.state.sport_count === sport_cate_detail.length ? "" :
                sport_cate_detail.length < 18 ? ""
                 : <div className="row">
                <button onClick={this.setPage}  className="btn btn-info center-block view-more-sport">Xem thêm..</button>
            </div>
            }
        </Fragment>
    );
  }
}
export default compose(
    graphql(GetSportPagination,{
        name:'getSportPagination',
        options: (ownProps) => ({
            variables: {
                id: ownProps.cate.category_id,
                channel:ownProps.cate.channel_id,
                limit:ownProps.cate.limit
            }
        })
    })
)(withRouter(
    connect(
        null
    )(SportCateDetail)
))


// WEBPACK FOOTER //
// ./src/components/Sports/SportCateDetail.js